/**
 * Theme-aware colours for recharts. Pass these strings straight into SVG
 * attributes (`fill`, `stroke`); the browser resolves the CSS variables so the
 * chart follows the active portal theme / dark mode.
 */
export const chartColors = {
  pos: 'rgb(var(--pos))',
  warn: 'rgb(var(--warn))',
  info: 'rgb(var(--info))',
  danger: 'rgb(var(--danger))',
  accent: 'rgb(var(--accent-rgb))',
  accent2: 'rgb(var(--accent2-rgb))',
  muted: 'rgb(var(--glass-text-muted))',
} as const;

export type ChartColorKey = keyof typeof chartColors;

export const chartTheme = {
  grid: 'rgb(var(--glass-border) / 0.2)',
  axisStroke: 'rgb(var(--glass-border) / 0.3)',
  tick: { fontSize: 11, fill: 'rgb(var(--glass-text-secondary))' },
  legend: { color: 'rgb(var(--glass-text-secondary))', fontSize: 12 },
  tooltip: {
    background: 'rgb(var(--glass-surface-1) / 0.95)',
    border: '1px solid rgb(var(--glass-border) / 0.2)',
    borderRadius: 12,
    color: 'rgb(var(--glass-text-primary))',
    fontSize: 12,
  },
} as const;
